<template>
    <div class="bee_list_base_layout">

        <div class="empty_share_btn" @click="doClick">

            <div class="empty_share_div"></div>

            <div class="empty_share_text">Share a link</div>

        </div>


    </div>
</template>

<script>

export default {
    name: 'inviteBtn',

    components: {

    },
    emits: ["clickShowLink"],
    props: {
        listData: [],
    },

    data() {
        return {
        }
    },

    watch: {
    },

    methods: {

        doClick() {
            this.$emit("clickShowLink", 0);
        },


    },

    mounted() {
    },


}

</script>

<style scoped>
.bee_list_base_layout {
    position: fixed;
    z-index: 2002;
    align-items: center;
    flex-direction: column;
    display: flex;
    bottom: 0px;
    right: 0;
    left: 0;
}



.empty_share_div {
    width: 16px;
    height: 16px;
    background-image: url("../../assets/icon_share_img.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.empty_share_text {
    color: #FFF;
    text-align: center;
    font-family: "SF Pro Display";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 4px;
}

.empty_share_btn {
    display: flex;
    border-radius: 8px;
    background: #FFAB13;
    height: 45px;
    margin-left: 16px;
    margin-right: 16px;
    width: -webkit-fill-available;
    width: -moz-available;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-bottom: 16px;
}
</style>